import { MouseEvent, ReactElement, ReactNode } from 'react';

interface ButtonProps {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  children?: ReactNode;
  icon?: ReactElement;
  className?: string;
  disabled?: boolean;
}

export default function Button({
  onClick,
  children,
  icon,
  className = '',
  disabled = false,
}: ButtonProps): ReactElement {
  return (
    <button
      className={`
        // Spacing and layout
        // Border and
        background // Text styles
        cr-flex cr-items-center cr-gap-1 cr-rounded-md
        cr-border-2 cr-border-solid cr-border-cirrusBlue-100
        cr-bg-cirrusBlue-25 cr-px-4 cr-py-2 cr-uppercase cr-text-[#002D50] cr-transition-colors cr-duration-200 hover:cr-bg-cirrusBlue-50 hover:cr-text-[#305D80]
        disabled:cr-bg-cirrusBlue-100 disabled:cr-text-[#002D50] disabled:cr-opacity-50
        ${className}`}
      style={{ fontFamily: '\'Zen Dots\', sans-serif' }}
      onClick={onClick}
      type="button"
      disabled={disabled}
    >
      {children} {icon}
    </button>
  );
}
